import * as amplitude from '@amplitude/analytics-browser';
import type { EventName, EventProperties } from './events';

/**
 * Lightweight analytics wrapper so the app doesn't depend directly on Amplitude everywhere.
 * This makes it easier to evolve naming, enrich payloads, or dual-write if needed.
 */
export const Analytics = {
    track(event: EventName | string, props?: EventProperties) {
        // Forward to Amplitude v2. Keep optional props.
        return amplitude.track(String(event), props as Record<string, any> | undefined);
    },

    setUserId(userId?: string | null) {
        // If null is passed, clear the current userId by forwarding undefined to Amplitude
        return amplitude.setUserId(userId ?? undefined);
    },

    setDeviceId(deviceId: string) {
        return amplitude.setDeviceId(deviceId);
    },

    identify(ops: amplitude.Identify) {
        return amplitude.identify(ops);
    },

    flush() {
        return amplitude.flush();
    }
};

export default Analytics;
